import { ActionType } from "../constants/resort";

import {
  countriesArrayApi,
  regionsArrayApi,
  resortsArrayApi
} from "../../api/resort/resort";

export const countriesArrayAction = () => dispatch => {
  return countriesArrayApi()
    .then(
      dispatch({
        type: ActionType.GET_COUNTRIES_ARRAY_START
      })
    )
    .then(response => {
      dispatch({
        type: ActionType.GET_COUNTRIES_ARRAY_SUCCESS,
        payload: response.data
      });
    })
    .catch(err => {
      dispatch({
        type: ActionType.GET_COUNTRIES_ARRAY_ERRORS,
        payload: err.response
      });
    });
};

export const regionsArrayAction = country_id => dispatch => {
  return regionsArrayApi(country_id)
    .then(
      dispatch({
        type: ActionType.GET_REGIONS_ARRAY_START
      })
    )
    .then(response => {

      dispatch({
        type:  ActionType.GET_REGIONS_ARRAY_SUCCESS,
        payload: response.data
      });
    })
    .catch(err => {
      dispatch({
        type: ActionType.GET_REGIONS_ARRAY_ERRORS,
        payload: err.response
      });
    });
};

export const resortsArrayAction = (region_id, page) => dispatch => {
  return resortsArrayApi(region_id, page)
    .then(
      dispatch({
        type:  ActionType.GET_RESORT_ARRAY_START
      })
    )
    .then(response => {
      dispatch({
        type: ActionType.GET_RESORT_ARRAY_SUCCESS,
        payload: response.data
      });
    })
    .catch(err => {
      dispatch({
        type: ActionType.GET_RESORT_ARRAY_ERRORS,
        payload: err.response
      });
    });
};
